import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static get values() {
    return {
      theme: String,
    };
  }

  connect() {
    this.theme = this.themeValue || 'default-theme';
    localStorage.setItem('theme', this.theme);

    window.addEventListener('culture-cal-theme-change', (e) => {
      const newTheme = e.detail.theme;
      this.themeChanged(newTheme);
    });
  }

  themeChanged(newTheme) {
    const oldTheme = this.theme;
    this.element.classList.add(newTheme);
    this.element.classList.remove(oldTheme);
    this.theme = newTheme;

    const notableDays = document.querySelectorAll('.notable-day');
    notableDays.forEach((day) => {
      day.classList.add(newTheme);
      day.classList.remove(oldTheme);
    });

    const calendarCells = document.querySelectorAll('.calendar-cell');
    calendarCells.forEach((cell) => {
      cell.classList.add(newTheme);
      cell.classList.remove(oldTheme);
    });
  }
}
